import { default as _StepinLayout } from './stepin-layout';
import { default as _StepinView } from './stepin-view';
import { default as _ColorCheckbox } from './color-checkbox';
import { default as _ConfigProvider } from './config-provider';
import { default as _Contextmenu } from './contextmenu';
import { default as _RouterMenu } from './router-menu';
import { default as _Icon } from './icon';
import { default as _ImgCheckbox } from './img-checkbox';
import { default as _LabelWrapper } from './label-wrapper';
import { default as _SettingPanel } from './setting-panel';
import { default as _TabsView } from './tabs-view';
import { default as _IframeBox } from './iframe-box';
import { default as _StepinLink } from './stepin-link';
import { default as _ColorPicker } from './color-picker';
import { default as _CodeSandbox } from './code-sandbox';
import { default as _AnchorBox } from './anchor-box';
import { default as _ApiTable } from './api-table';
import { default as _StreamLayout } from './stream-layout';
import { default as _AlertMessage } from './alert-message';
import { default as _ThemeProvider } from './theme-provider';
import { default as _ThemeEditor } from './theme-editor';
export { alert } from './alert-message';
export { StepinHeaderAction } from './stepin-view';
var components = [_StepinLayout, _StepinView, _ColorCheckbox, _ConfigProvider, _Contextmenu, _RouterMenu, _Icon, _ImgCheckbox, _LabelWrapper, _SettingPanel, _TabsView, _IframeBox, _StepinLink, _ColorPicker, _CodeSandbox, _AnchorBox, _ApiTable, _StreamLayout, _AlertMessage, _ThemeProvider];
export var StepinLayout = _StepinLayout;
export var StepinView = _StepinView;
export var ColorCheckbox = _ColorCheckbox;
export var ConfigProvider = _ConfigProvider;
export var Contextmenu = _Contextmenu;
export var SMenu = _RouterMenu;
export var Icon = _Icon;
export var ImgCheckbox = _ImgCheckbox;
export var LabelWrapper = _LabelWrapper;
export var SettingPanel = _SettingPanel;
export var TabsView = _TabsView;
export var IframeBox = _IframeBox;
export var StepinLink = _StepinLink;
export var ColorPicker = _ColorPicker;
export var CodeSandbox = _CodeSandbox;
export var AnchorBox = _AnchorBox;
export var ApiTable = _ApiTable;
export var StreamLayout = _StreamLayout;
export var AlertMessage = _AlertMessage;
export var ThemeProvider = _ThemeProvider;
export var ThemeEditor = _ThemeEditor;
var stepinPlugin = {
  install: function install(app) {
    for (var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      options[_key - 1] = arguments[_key];
    }
    components.forEach(function (component) {
      app.use.apply(app, [component].concat(options));
    });
  }
};
export default stepinPlugin;